import { useState, useEffect } from "react";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { getTickets, updateTicket } from "services/ticketService";

const StatusCell = ({ status }) => {
  let color = "error";
  if (status === "Gelöst") color = "success";
  else if (status === "In Bearbeitung") color = "warning";
  else if (status === "Offen") color = "info";

  return (
    <SoftBox>
      <SoftTypography variant="caption" color={color} fontWeight="medium">
        {status}
      </SoftTypography>
    </SoftBox>
  );
};

StatusCell.propTypes = {
  status: PropTypes.string.isRequired,
};

const ActionCell = ({ ticketId, onDetails, onClose }) => {
  return (
    <SoftBox display="flex" gap={2}>
      <Tooltip title="Ticket-Details" placement="top">
        <SoftButton
          onClick={() => onDetails(ticketId)}
          variant="text"
          color="info"
          size="sm"
          iconOnly
        >
          <Icon>chat</Icon>
        </SoftButton>
      </Tooltip>
      <Tooltip title="Fall schließen" placement="top">
        <SoftButton
          onClick={() => onClose(ticketId)}
          variant="text"
          color="error"
          size="sm"
          iconOnly
        >
          <Icon>check_circle</Icon>
        </SoftButton>
      </Tooltip>
    </SoftBox>
  );
};

ActionCell.propTypes = {
  ticketId: PropTypes.string.isRequired,
  onDetails: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const useTicketsData = () => {
  const [tickets, setTickets] = useState([]);

  const loadTickets = async () => {
    try {
      const data = await getTickets();
      setTickets(data);
    } catch (error) {
      console.error("Fehler beim Laden der Tickets:", error);
    }
  };

  const handleDetails = (ticketId) => {
    // Diese Funktion wird jetzt vom übergeordneten Komponenten verwendet
    console.log("Show details for ticket:", ticketId);
  };

  const handleClose = async (ticketId) => {
    try {
      await updateTicket(ticketId, { status: "Gelöst" });
      await loadTickets(); // Aktualisiere die Liste nach dem Schließen
    } catch (error) {
      console.error("Fehler beim Schließen des Tickets:", error);
    }
  };

  useEffect(() => {
    loadTickets();
  }, []);

  const columns = [
    { Header: "Ticket-Nr.", accessor: "id", width: "10%" },
    { Header: "Betreff", accessor: "subject", width: "30%" },
    { Header: "Datum", accessor: "createdAt", width: "15%" },
    { Header: "Priorität", accessor: "priority", width: "15%" },
    { Header: "Status", accessor: "status", width: "15%" },
    { Header: "Aktionen", accessor: "actions", width: "15%" },
  ];

  const rows = tickets.map((ticket) => ({
    id: `T-${ticket.id}`,
    subject: ticket.subject,
    createdAt: new Date(ticket.createdAt).toLocaleDateString('de-DE'),
    priority: ticket.priority,
    status: <StatusCell status={ticket.status} />,
    actions: (
      <ActionCell
        ticketId={ticket.id}
        onDetails={handleDetails}
        onClose={handleClose}
      />
    ),
  }));

  return { columns, rows, loadTickets };
};

export default useTicketsData;